import cn from 'classnames';

import { IConDefaultType } from '../types';

export interface IBgMusicIconProps extends IConDefaultType {}

export default function BgMusicIcon({ color, className, size = 24, rotate, flip }: IBgMusicIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 2C8.79086 2 7 3.79086 7 6V14.5351C6.41165 14.1948 5.72857 14 5 14C2.79086 14 1 15.7909 1 18C1 20.2091 2.79086 22 5 22C7.20914 22 9 20.2091 9 18V9H19V14.5351C18.4117 14.1948 17.7286 14 17 14C14.7909 14 13 15.7909 13 18C13 20.2091 14.7909 22 17 22C19.2091 22 21 20.2091 21 18V6C21 3.79086 19.2091 2 17 2H11ZM19 18C19 16.8954 18.1046 16 17 16C15.8954 16 15 16.8954 15 18C15 19.1046 15.8954 20 17 20C18.1046 20 19 19.1046 19 18ZM19 7V6C19 4.89543 18.1046 4 17 4H11C9.89543 4 9 4.89543 9 6V7H19ZM7 18C7 16.8954 6.10457 16 5 16C3.89543 16 3 16.8954 3 18C3 19.1046 3.89543 20 5 20C6.10457 20 7 19.1046 7 18Z"
          fill={color || '#8A8A8A'}
        />
      </svg>
    </i>
  );
}
